export abstract class ListResource {
  page = 1
  per_page = 12
  search? = ""
  filter = ""
  order_by? = ""
  params? = {}

  setPage(page: number) {
    this.page = page
  }

  setPerPage(perPage: number) {
    this.per_page = perPage
  }

  setSearch(search?: string) {
    this.search = search
  }

  setOrder(order?: string) {
    this.order_by = order
  }

  setParams() {
    let params: object = {
      page: this.page,
      page_size: this.per_page
    }
    if (this.search) {
      params = {
        ...params,
        filter: this.search
      }
    }
    if (this.order_by) {
      params = {
        ...params,
        sort: this.order_by
      }
    }
    this.params = { params }
  }
}
